import { CHAT_WIDGET_ID } from 'app/constants/LibraryConstants';

export default library => {
  const chatWidgets = library.get('chatWidgets');
  const allowedWidgets = chatWidgets.delete(CHAT_WIDGET_ID.UNIQUE_CHAT);
  const enabledWidgetId = allowedWidgets.findLastKey(widget => widget.get('enabled'));

  return enabledWidgetId ?? null;
};
